<div class="content" role="main">

  <img src="https://uploads-ssl.webflow.com/62e7baff16ec36495482a367/62e80d76efedf4f5838b4bd0_logo.svg" alt="Logo of KaDeck"  style="width: 180px; margin-bottom: 70px"/>

<!--    <mat-icon aria-hidden="false" aria-label="Offline activation" color="primary" style="margin: 20px 0;">cloud</mat-icon>-->
  <h1>Offline Activation</h1>
  <p style="text-align: center; margin-bottom: 50px"><b>1.</b> Enter the challenge code from KaDeck's offline activation page below and click on "Activate instance".<br/><b>2.</b> Then copy the response code back into the corresponding "Response" field in KaDeck.</p>

  <ng-container [ngSwitch]="status">

    <mat-spinner id="spinner" [diameter]="50" *ngSwitchCase="'loading'"></mat-spinner>
    <p style="text-align: center">
      <button *ngSwitchCase="'success'"  mat-raised-button color="primary" (click)="copyToClipboard()">Copy response code</button>
    </p>

    <div class="circleicon error" *ngSwitchCase="'failure'">
      <mat-icon aria-hidden="false" aria-label="Failure" color="warn">error</mat-icon>
    </div>

  </ng-container>

  <!-- Highlight Card -->
  <div class="card highlight-card card-small" style="margin-bottom: 50px" *ngIf="statusmessage && status !== 'success'">
    {{ statusmessage }}
  </div>

  <div id="responsecode" *ngIf="responsecode">
    <div class="responsecodeheader">Enter this response code in KaDeck Web</div>
    <div class="responsecodevalue">
      {{ responsecode }}
    </div>
  </div>

  <p *ngIf="status==='failure'">If you think something is wrong, <a target="_blank" href="mailto:support@xeotek.com">contact us</a>.</p>
  <button mat-raised-button color="accent"  style="margin: 20px 0" *ngIf="status === 'failure'"
          (click)="this.status='none'; this.statusmessage=''">Retry
  </button>
  <div class="challengecodeeditor" *ngIf="status === 'none'">
    <span id="challengeinfo">Paste your challenge code</span>
    <textarea [formControl]="challengeCode" rows="7" cols="80" placeholder="Paste your challenge code here"
              (paste)="onChallengeEntered()" (input)="onChallengeEntered()"></textarea>
    <span id="challengevalidation"
          [ngClass]="{'grey':validation==='Paste challenge', 'success':validation==='true','error':validation!=='true' && validation!=='Paste challenge'}">{{validation !== 'true' ? validation : 'Valid'}}</span>
  </div>
  <button mat-raised-button color="primary" id="challengesubmit" [disabled]="validation!=='true'" *ngIf="status === 'none'"
          (click)="activateInstance()">Activate instance
  </button>



  <div class="licenceinformation" *ngIf="status === 'instance'" style="text-align: center">
    <mat-icon aria-hidden="false" aria-label="Warning" color="warn" style="font-size: 30px; width: auto;">warning</mat-icon>

    <h2 style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">You already have one activated KaDeck Web
      environment</h2>
    <p style="text-align: center">By clicking on the button "Confirm and activate new instance" you confirm that you
      have read the information "Note about running independent KaDeck Web instances", and "Using multiple KaDeck
      instances" (below), and that the currently associated KaDeck Web environment is no longer used.</p>
    <p style="text-align: center; margin: 40px 0"><button mat-raised-button color="accent" id="newinstanceconfirmation" (click)="activateInstance(true)">Confirm and active new instance</button></p>

    <h2 style="margin-top: 20px;">Note about running independent KaDeck Web instances</h2>
    <p style="text-align: center">The parallel use of a team and associated user licenses across independent, active
      (running) instances of KaDeck Web is prohibited. If you activate a new KaDeck Web instance using offline
      activation, please ensure that a previously activated instance is no longer used.</p>
    <h2 style="margin-top: 50px">Using multiple KaDeck instances</h2>
    <p style="text-align: center; margin-bottom: 40px; display: inline-block">Please note that licences are always
      issued for one environment (database) of KaDeck Web. You can connect and manage multiple clusters from one KaDeck
      Web environment. This means that you can run several KaDeck Web instances (e.g. for high availability scenarios)
      with access to the same database, but cannot use user licences across several independent KaDeck Web instances. If
      you want to operate several independent instances, you need a separate team (each with user licences) for each
      independent environment.</p>
    <div class="card-container">
      <a class="card" target="_blank" rel="noopener" href="https://support.xeotek.com">
        <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
        </svg>

        <span>More about licences</span>

        <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </a>

      <a class="card" target="_blank" rel="noopener" href="https://support.xeotek.com">
        <mat-icon style="margin-right: 10px">help</mat-icon>

        <span>Support Center</span>

        <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </a>


    </div>

  </div>


</div>
